/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_TracksInputs */



/**
* | output |
* | --- |
* | "Export Tracks" |
*
* @param {Export_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const export_tracks = /** @type {((inputs?: Export_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pistes d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export Tracks")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tracce di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспортные пути")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rutas de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートトラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar faixas")
	return /** @type {LocalizedString} */ ("Export Tracks")
});